import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SortEnum } from 'src/app/utils/enums/sort-enum';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Groupe } from 'src/app/utils/interfaces/new/groupe.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { environment } from 'src/environments/environment';
import { FiltresService } from '../filtres/filtres.service';
import { SnackbarService } from '../snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class GroupeService {

  private isMock = environment.mock;

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };

  private apiUri = environment.basePath + '/medical/groupes';
  private _wait = (ms) => new Promise(res => setTimeout(res, ms));

  constructor(
    private _http: HttpClient,
    private _filtresService: FiltresService,
    private _snack: SnackbarService
  ) { }

  public async find(filtre: Filtres = {
    perpage: -1,
    currentPage: 1,
    sortOrder: SortEnum.ASC,
    sortBy: 'nom'
  }): Promise<Paginated<Groupe>> {
    try {
      this.httpOptions.headers = this._filtresService.setHeaders(filtre);
      const res = await this._http.get(this.apiUri, this.httpOptions).toPromise();
      const groupes = res.body as Groupe[];
      const paginated: Paginated<Groupe> = {
        page: Number(res.headers.get('x-page')),
        perpage: Number(res.headers.get('x-per-page')),
        total: Number(res.headers.get('x-total')),
        objects: groupes
      };
      return paginated;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async findOne(id: string) {
    try {
      const res = await this._http.get(this.apiUri + '/' + id, this.httpOptions).toPromise();
      const groupe = res.body as Groupe;
      return groupe;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async create(groupe: Groupe) {
    try {
      const res = await this._http.post(this.apiUri, groupe, this.httpOptions).toPromise();
      return res.body;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async delete(groupe: Groupe) {
    try {
      groupe.disabled = true;
      const res = await this._http.put(this.apiUri + '/' + groupe.id, groupe, this.httpOptions).toPromise();
      return;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async update(groupe: Groupe) {
    try {
      const res = await this._http.put(this.apiUri + '/' + groupe.id, groupe, this.httpOptions).toPromise();
      return;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }
}
